import {TidStatusDto} from "./TidStatusDto";

export interface ITerminalDto {
    terminalId: string;
    tidStatus: TidStatusDto;
    terminalType: string;
    users: string[] | undefined;
    softposType: string,
}

export class TerminalDto implements ITerminalDto {
    public terminalId: string;
    public tidStatus: TidStatusDto;
    public terminalType: string;
    public users: string[] | undefined;
    public softposType: string;

    constructor(terminalId: string, tidStatus: TidStatusDto, terminalType: string,  users: string[], softposType: string) {
        this.terminalId = terminalId;
        this.tidStatus = tidStatus;
        this.terminalType = terminalType;
        this.users = users;
        this.softposType = softposType;
    }
}
